import { makeApolloClient, logError } from '../util';
import {
	ATTENDEE,
	EVENT_ATTENDEE_METADATA,
	ATTENDEE_AGENDA,
	TOKENS,
	EVENT_ATTENDEE_LIMITED,
} from 'queries/attendee';
export const SET_SINGLE_ATTENDEE = 'SET_SINGLE_ATTENDEE';
export const SET_ATTENDEE_METADATA = 'SET_ATTENDEE_METADATA';
export const SET_ATTENDEE_AGENDA = 'SET_ATTENDEE_AGENDA';
export const CREATE_ATTENDEE = 'CREATE_ATTENDEE';
export const UPDATE_ATTENDEE = 'UPDATE_ATTENDEE';
export const UPDATE_ATTENDEE_METADATA = 'UPDATE_ATTENDEE_METADATA';
export const DELETE_ATTENDEE = 'DELETE_ATTENDEE';
export const ADD_MANY_GROUPS_TO_ATTENDEE = 'ADD_MANY_GROUPS_TO_ATTENDEE';
export const REMOVE_MANY_GROUPS_FROM_ATTENDEE = 'REMOVE_MANY_GROUPS_FROM_ATTENDEE';
export const REMOVE_MANY_ATTENDEES_FROM_EVENT = 'REMOVE_MANY_ATTENDEES_FROM_EVENT';
export const CLEAR_ATTENDEE_DATA = 'CLEAR_ATTENDEE_DATA';
export const UPDATE_ATTENDEE_AGENDA_ITEM = 'UPDATE_ATTENDEE_AGENDA_ITEM';
export const DUPLICATE_ATTENDEE_AGENDA_ITEM = 'DUPLICATE_ATTENDEE_AGENDA_ITEM';
export const DELETE_ATTENDEE_AGENDA_ITEM = 'DELETE_ATTENDEE_AGENDA_ITEM';
export const SET_PUSH_ANNOUNCEMENT_TOKENS = 'SET_PUSH_ANNOUNCEMENT_TOKENS';

const setSingleAttendee = ({ attendee, from }) => ({
	type: SET_SINGLE_ATTENDEE,
	attendee,
	from,
});

const setAttendeeMetaData = ({ eventAttendeeMetadata, from }) => ({
	type: SET_ATTENDEE_METADATA,
	eventAttendeeMetadata,
	from,
});

const setAttendeeAgenda = ({ attendeeAgenda, from }) => ({
	type: SET_ATTENDEE_AGENDA,
	attendeeAgenda,
	from,
});

const setAttendeePushAnnouncementTokens = ({ pushAnnouncementTokens, from }) => ({
	type: SET_PUSH_ANNOUNCEMENT_TOKENS,
	pushAnnouncementTokens,
	from,
});

export const createAttendee = ({ attendee }) => ({
	type: CREATE_ATTENDEE,
	attendee,
});

export const updateAttendee = ({ attendee }) => ({
	type: UPDATE_ATTENDEE,
	attendee,
});

export const updateAttendeeMetaData = ({ metadata }) => ({
	type: UPDATE_ATTENDEE_METADATA,
	metadata,
});

export const duplicateAttendeeAgendaItem = agendaItem => ({
	type: DUPLICATE_ATTENDEE_AGENDA_ITEM,
	agendaItem,
});

export const updateAttendeeAgendaItem = agendaItem => ({
	type: UPDATE_ATTENDEE_AGENDA_ITEM,
	agendaItem,
});

export const deleteAttendeeAgendaItem = ({ id }) => ({
	type: DELETE_ATTENDEE_AGENDA_ITEM,
	agendaItemID: id,
});

export const deleteAttendee = ({ attendeeID }) => ({
	type: DELETE_ATTENDEE,
	deleteAttendeeID: attendeeID,
});

export const addGroupsToAttendee = ({ groups }) => ({
	type: ADD_MANY_GROUPS_TO_ATTENDEE,
	groups,
});

export const removeGroupsFromAttendee = ({ groups }) => ({
	type: REMOVE_MANY_GROUPS_FROM_ATTENDEE,
	groups,
});

export const removeAttendeeFromEvent = ({ attendeeIDs }) => ({
	type: REMOVE_MANY_ATTENDEES_FROM_EVENT,
	attendeeIDs,
});

export const clearAttendeeData = from => ({
	type: CLEAR_ATTENDEE_DATA,
	from,
});

export const thunkFetchSingleAttendee = (attendeeID, from) => async (dispatch, getState) => {
	const client = makeApolloClient(getState());
	try {
		const { attendee } = await client.request(ATTENDEE, { id: attendeeID });
		dispatch(setSingleAttendee({ attendee, from }));
	} catch (error) {
		dispatch(setSingleAttendee({ attendee: { error: 'User does not exist' } }));
		logError('attendee.actions.thunkFetchSingleAttendee', error);
	}
};

export const thunkFetchAttendeeMetadata = (attendeeID, eventID, from) => async (
	dispatch,
	getState
) => {
	const client = makeApolloClient(getState());

	try {
		const { eventAttendeeMetadata } = await client.request(EVENT_ATTENDEE_METADATA, {
			id: attendeeID,
			event_id: eventID,
		});
		dispatch(setAttendeeMetaData({ eventAttendeeMetadata, from }));
	} catch (error) {
		logError('attendee.actions.thunkFetchAttendeeMetadata', error);
	}
};

export const thunkFetchAttendeeAgenda = (attendeeID, eventID, from) => async (
	dispatch,
	getState
) => {
	const client = makeApolloClient(getState());
	try {
		const { attendeeAgenda } = await client.request(ATTENDEE_AGENDA, {
			event_id: eventID,
			attendee_id: attendeeID,
		});
		dispatch(setAttendeeAgenda({ attendeeAgenda, from }));
	} catch (error) {
		logError('attendee.actions.thunkFetchAttendeeMetadata', error);
	}
};

export const thunkFetchAttendeeTokens = (attendeeID, from) => async (dispatch, getState) => {
	const client = makeApolloClient(getState());
	try {
		const { pushAnnouncementTokens } = await client.request(TOKENS, {
			attendee_id: attendeeID,
		});
		dispatch(setAttendeePushAnnouncementTokens({ pushAnnouncementTokens, from }));
	} catch (error) {
		logError('attendee.actions.thunkFetchAttendeeTokens', error);
	}
};

export const thunkFetchLimitedAttendeeData = (attendeeID, from) => async (dispatch, getState) => {
	const client = makeApolloClient(getState());
	try {
		const { attendee } = await client.request(EVENT_ATTENDEE_LIMITED, { id: attendeeID });
		dispatch(setSingleAttendee({ attendee, from }));
	} catch (error) {
		dispatch(setSingleAttendee({ attendee: { error: 'User does not exist' } }));
		logError('attendee.actions.thunkFetchLimitedAttendeeData', error);
	}
};
